import { Helmet } from "react-helmet-async";

export default function MetaComponent({ meta }) {
  const siteOrigin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
  const fallbackImage = siteOrigin ? `${siteOrigin}/logoamr.png` : "/logoamr.png";

  const resolveImageUrl = (value) => {
    const imageValue = String(value || "").trim();

    if (!imageValue) {
      return fallbackImage;
    }

    if (/^https?:\/\//i.test(imageValue)) {
      return imageValue;
    }

    if (siteOrigin && imageValue.startsWith("/")) {
      return `${siteOrigin}${imageValue}`;
    }

    return imageValue.startsWith("/") ? imageValue : `/${imageValue}`;
  };

  const ogImage = resolveImageUrl(meta?.image);

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{meta?.title}</title>

      <meta name="robots" content={meta?.robots || "index, follow, max-image-preview:large"} />
      <meta name="language" content={meta?.language || "English"} />
      <meta name="author" content={"AskMeRealty Editorial Team"} />
      {meta?.canonical ? <link rel="canonical" href={meta.canonical} /> : null}

      <meta name="title" content={meta?.title} />
      <meta name="description" content={meta?.description} />
      <meta name="keywords" content={meta?.keywords} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={meta?.title} />
      <meta property="og:description" content={meta?.description} />
      <meta property="og:site_name" content={meta?.siteName || "AskMeReality"} />
      {meta?.url ? <meta property="og:url" content={meta.url} /> : null}
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={"summary_large_image"} />
      <meta name="twitter:title" content={meta?.title} />
      <meta name="twitter:description" content={meta?.description} />
      {meta?.url ? <meta name="twitter:url" content={meta.url} /> : null}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
